import {Platform} from 'react-native';
import Config from 'react-native-config';

import VisitWebsitePopover from '/component/partial/VisitWebsitePopover';
import {openURL, openURLInNewTabOnWeb} from '/util/linking.util';

export const generateGoToOptaviaPayLink = (
  {popoverShow}: any,
  currentScreen: string,
  isScreenReaderOn: any,
) => {
  return (payload: {triggerRef?: React.RefObject<any>}) => {
    if (Platform.OS === 'web') {
      return openURLInNewTabOnWeb(Config.OPTAVIA_PAY_LINK);
    }

    popoverShow(VisitWebsitePopover, {
      onSubmit: () => openURL('url', Config.OPTAVIA_PAY_LINK),
      currentScreen: currentScreen,
      triggerRef: payload.triggerRef,
      useModal:
        Platform.OS === 'web'
          ? false
          : Platform.OS === 'ios'
          ? !isScreenReaderOn
          : true,
    });
  };
};

export const generateGoToOptaviaApp = (
  {popoverShow}: any,
  currentScreen: string,
  isScreenReaderOn: any,
) => {
  return (payload: {triggerRef?: React.RefObject<any>}) => {
    if (Platform.OS === 'web') {
      return openURLInNewTabOnWeb(Config.OPTAVIA_APP_LINK);
    }

    popoverShow(VisitWebsitePopover, {
      onSubmit: () => openURL('url', Config.OPTAVIA_APP_LINK),
      currentScreen: currentScreen,
      triggerRef: payload.triggerRef,
      useModal:
        Platform.OS === 'web'
          ? false
          : Platform.OS === 'ios'
          ? !isScreenReaderOn
          : true,
    });
  };
};
